export enum Layouts {
  Landing = '/landing',
  Admin = '/admin',
  Employeee = '/employee'
}
